[
    {
        "group": "Documentation",
        "itemNumber": "1",
        "clauseId": "Documentation 1",
        "standardRef": "AS/NZS 5139:2019 Clause 6.4.1.2",
        "question": "Has full system manual incorporating all components of AS/NZS 5139:2019 Clause 6.4.1.2, been provided to the homeowner?",
        "recommendations": [
            "Battery system information including the below items has not been provided:(i) Total battery storage capacity. (ii) Australian and/or New Zealand address and contact details for the manufacturer’s representative (or deemed equivalent).(iii) UN Number for the battery cell or battery system. (iv) Commissioning date. (v) System provider contact details.",
            "A complete list of installed equipment, with model description and serial numbers has not been included in the documentation.",
            "System performance and operation configuration: system output performance including expected operating response based on programming, expected life of battery system, end of life system parameters and expected operational life. has not been included in the documentation.",
            "A short description of the function and operation of all installed equipment has not been included in the documentation.",
            "Operational instructions for response requirements to battery system or BESS alarms that may be required as part of the installation has not been included in the documentation.",
            "Description and meaning of any state of health measurements, where provided has not been included in the documentation.",
            "Shutdown and isolation procedure for emergency has not been included in the documentation.",
            "Start-up procedure and verification checks has not been included in the documentation.",
            "Description of how to identify when the system is not operating correctly and what to do in the case of a system failure. Details about alarm systems installed as part of the system and in addition to the system have not been included as part of the documentation.",
            "maintenance procedures, a checklist for the installed equipment and schedule for these tasks including hazard mitigation requirements for maintenance tasks. Including shutdown and isolation procedure for maintenance, this may be different to emergency shutdown procedure.",
            "Commissioning records and installation checklist: A record of the initial system settings and firmware version at the time of system installation, verification records, commissioning checklists for quality assurance and date of installation.",
            "System connection diagram: A diagram showing the electrical connections of the battery system with the PCE(s).",
            "Equipment manufacturer’s documentation, data sheets, safety data sheets (SDS) for batteries and handbooks — for all equipment supplied. Where systems have an Ethernet or other form of data interface, include all information on connection requirements and system operating manuals.",
            "A copy of the risk assessment undertaken for Clause 6.2.1 including information on specific requirements to address all risks (for example, the action to take when toxic fumes are present).",
            "Decommissioning information for battery replacement or battery removal including safe handling procedures for the battery system or BESS and recommendations for recycling."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "13",
        "clauseId": "SB & Labelling 13",
        "standardRef": "AS/NZS 4777.1:2024 Clause 5.3.6.4; AS/NZS 3000:2018 amendment 2 Clause 2.6.3.2.5 (a)",
        "question": "Do the alternative supply circuits have appropriate RCD protection?",
        "recommendations": [
            "Alternative supply circuits have been backed up by battery system, altering their source of supply, and RCD protection has not been installed on some/all the backed-up circuits."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "14",
        "clauseId": "SB & Labelling 14",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.3.3.2.2 & 8.3.3.3.2.; AS/NZS 3000:2018 Clause 8.3.7.2 (f)",
        "question": "Are there any parallel earth-neutral (secondary MEN) connections present in the battery system/inverter or associated wiring?",
        "recommendations": [
            "A parallel earth-neutral connection has been found on the inverter/battery circuit through testing. AS/NZS 3000 Clause 8.3.7.1 (f)"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "15",
        "clauseId": "SB & Labelling 15",
        "standardRef": "AS/NZS 4777.1:2024 Clause 5.3.2.2 & 8.3.4.4.2",
        "question": "Is neutral continuity maintained for all circuits provided and operating on an alternative supply?",
        "recommendations": [
            "The alternative supply final sub circuits do not appear to maintain neutral continuity when placed into back up mode."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "21",
        "clauseId": "SB & Labelling 21",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.4.1 (a);",
        "question": "After turning on the \"MAIN SWITCH(INVERTER)\" does it take greater than 60 seconds for current to be shown on the supplementary supply active conductor?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "22",
        "clauseId": "SB & Labelling 22",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.4.1 (b)",
        "question": "After turning off the \"MAIN SWITCH(INVERTER)\" does it take less than 2 seconds for current to dissipate from the supplementary supply active conductor?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "21",
        "clauseId": "Integrated BESS 21",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.1",
        "question": "Is the a.c. interconnection of the lithium-ion pre-assembled integrated BESS to the switchboard or distribution board in accordance with AS/NZS 3000? if not, is the defect not likely to cause a potential safety risk at some stage in the life of the system?",
        "recommendations": [
            "The neutral for supplementary and/or alternative supplies have not been marked or arranged to indicate the associated connected protective device. AS/NZS 3000:2018 Clause 2.10.5.4 Referencing Gateway.",
            "The Ac conduit at battery unit is not secured. Fix the conduit into place using conduit saddles.",
            "Install the Ac isolator enclosure at the inverter in a manner that maintains the manufacturer’s IP rating. Pips covering enclosure screws on lid are missing.",
            "Please Identify corresponding neutral connection e.g. (N.4). Inverter Supply Main Switch shall be marked or arranged to identify the corresponding active and neutral connections for each circuit. (AS/NZS 3000:2018 Cl 2.10.5.4) Referencing Gateway",
            "Install pole fillers to the DB switchboard so that fingers cannot access live parts without the use of a tool.",
            "The enclosure besides the main switchboard containing multiple protection devices for supplementary and alternative supplies, is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As such it is required to have a neutral bar provided with separate neutral terminals for each neutral circuit connected in said switchboard as per AS/NZS 3000:2018 Clause 2.10.4.3.",
            "Install the Ac isolator enclosure at the inverter in a manner that maintains the manufacturer’s IP rating. Seal mounting holes and cable entry holes at back of isolator.",
            "The installed gland where cables exit the enclosure and conduit is only suitable for a single cable, reinstall using a gland that is designed for multiple cables.",
            "LV and ELV insulated cables have been installed in proximity without adequate separation or segregation AS/NZS 3000 Clause 3.9.8.3",
            "3.9.3.3.2 Support and protection Wiring systems installed in positions where they are likely to be disturbed shall be supported at suitable intervals to prevent the undue sagging of cables; and supported to prevent accidental withdrawal of cables from electrical equipment exposing single-insulated conductors; and protected from mechanical damage as specified in Clause 3.3.2.6.",
            "At the AC point of connection plug at inverter double insulation is not maintained all the way into the plug. Therefore, single insulation is exposed. AS/NZS 3000:2018 1.8 & 8.2.2(v), 8.3.3 (b) manufactures installation guidelines"
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "22",
        "clauseId": "Integrated BESS 22",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.1 AS/NZS 5139:2019 CL 4.3.1.1",
        "question": "If the a.c interconnection of the lithium-ion pre-assembled integrated BESS to the switchboard or distribution board is not in accordance with AS/NZS 3000, is it such that it constitutes a safety hazard which poses an imminent risk?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "37",
        "clauseId": "Integrated BESS 37",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.1.2 AS/NZS 4777.1:2024",
        "question": "Do all grid connections of the pre-assembled BESS meet the requirements of AS/NZS 4777.1?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "38",
        "clauseId": "Integrated BESS 38",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.1.3.1 AS/NZS 3000",
        "question": "Has the earthing of the lithium-ion pre-assembled integrated BESS been installed to manufactures requirements and meet the earthing requirements in AS/NZS 3000?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "46",
        "clauseId": "Integrated BESS 46",
        "standardRef": "AS/NZS 3000",
        "question": "\"Are there any accessible live parts? Allowing direct contact with any equipment, component, terminals or connection, tested to be LIVE and accessible by 1 action to be touched. \"",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "47",
        "clauseId": "Integrated BESS 47",
        "standardRef": "AS/NZS 3000:2018",
        "question": "Are there connectors, couplings, covers or components able to be removed without the use of a tool which provide access to live parts?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "49",
        "clauseId": "Integrated BESS 49",
        "standardRef": "AS/NZS 3000:2018, AS/NZS 5139:2019, AS/NZS 5033:2021, AS/NZS 4777.1:2024",
        "question": "Has any electrical work associated with the installation of the lithium-ion pre-assembled integrated BESS not been installed in line with Australian standards such that it is not likely to cause a potential safety hazard now or for the expected lifetime of the system?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "50",
        "clauseId": "Integrated BESS 50",
        "standardRef": "AS/NZS 3000:2018, AS/NZS 5139:2019, AS/NZS 5033:2021, AS/NZS 4777.1:2024",
        "question": "Has any electrical work associated with the installation of the lithium ion pre-assembled integrated BESS not been installed in line with Australian standards such that it constitutes a safety hazard which poses an imminent risk?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "51",
        "clauseId": "Integrated BESS 51",
        "standardRef": "AS/NZS 3000",
        "question": "Are there any loose connections in the pre-assembled integrated BESS and associated wiring with no signs of heat",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "52",
        "clauseId": "Integrated BESS 52",
        "standardRef": "AS/NZS 3000",
        "question": "Are there any loose connections in the pre-assembled integrated BESS and associated wiring with signs of heat",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "4",
        "clauseId": "Integrated BESS 4",
        "standardRef": "AS/NZS 5139:2019 CL 4.4.2.3",
        "question": "Are there any signs of alterations or additions that would result in the lithium-ion pre-assembled integrated BESS no longer conforming to the Best Practice Guide: Battery Storage Equipment- Electrical Safety Requirements?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "5",
        "clauseId": "Integrated BESS 5",
        "standardRef": "AS/NZS 5139:2019 CL 4.4.2.3",
        "question": "Are the signs of alterations or additions that make the lithium-ion pre-assembled integrated BESS no longer conforming such that it is unsafe?",
        "recommendations": [
            "Integrated BESS 12",
            "Has the lithium-ion integrated BESS been recalled by the manufacturer or regulator?"
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "18",
        "clauseId": "Integrated BESS 18",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.1",
        "question": "Has the lithium-ion pre-assembled integrated BESS been installed in accordance with manufacturers installation requirements, including reference to the relevant SDS?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "24",
        "clauseId": "Integrated BESS 24",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.1 (a) AS/NZS 5139:2019 CL 4.2.5 600mm min, 900mm if accessing 230V",
        "question": "If installed indoors does the location of the lithium-ion pre-assembled integrated BESS allow access to the connections and any serviceable equipment, doors and panels that are required to be accessed for installation and maintenance.",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "25",
        "clauseId": "Integrated BESS 25",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.1 AS/NZS 3000:2018 Section 6",
        "question": "Does the location of the lithium-ion pre-assembled integrated BESS conform to the requirements for damp situations defined by AS/NZS 3000:2018 Section 6?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "39",
        "clauseId": "Integrated BESS 39",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.1.3.2",
        "question": "If required by the manufacturer of the pre-assembled integrated BESS, has an earth fault alarm been installed?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "43",
        "clauseId": "Integrated BESS 43",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.6 AS/NZS 5139:2019 Table 3.1",
        "question": "Where the lithium-ion pre-assembled integrated BESS is categorized as having an explosive gas hazard in AS/NZS 5139:2019 Table 3.1, is the installation in accordance with the instructions of the manufacturer including any venting and containment requirements?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "44",
        "clauseId": "Integrated BESS 44",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.7 AS/NZS 5139:2019 Table 3.1",
        "question": "Where the lithium-ion pre-assembled integrated BESS is categorized as having a toxic fume hazard in AS/NZS 5139:2019 Table 3.1, is the installation in accordance with the instructions of the manufacturer?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "45",
        "clauseId": "Integrated BESS 45",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.8",
        "question": "Does the lithium-ion pre-assembled integrated BESS have an alarm system provided that will cause an action to be initiated to correct the fault? This could be audible, visual or via an electronic communication.",
        "recommendations": [
            "SB & Labelling 11 – (AS/NZS 4777.1:2024 clause 5.3.6.2)",
            "Have battery/inverter systems utilizing an alternative supply been supplied with an alternative supply main switch in the switchboard they are supplying?.1:"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "27",
        "clauseId": "SB & Labelling 27",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.1 & 5.3.4",
        "question": "Are circuits that are backed up when the grid is not available grouped?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "33",
        "clauseId": "SB & Labelling 33",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.4.1 (b)",
        "question": "For systems with alternative supply, is anti-islanding maintained, when \"MAIN SWITCH(GRID)\" is turned off.",
        "recommendations": [
            "Voltage tested on load side of main switch (grid), when in the off position, indicating anti-islanding of multi-mode inverter is not maintained when grid connection is lost."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "19",
        "clauseId": "Integrated BESS 19",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.3.2 & 5.3.3",
        "question": "If the battery/inverter is not within 3 meters and line of site of switchboard it is connected to, has an AC isolation device/s, that is able to be secured in the open position, been provided adjacent to the battery/inverter to isolate both supplementary and alternative supplies if applicable?",
        "recommendations": [
            "Battery/Inverter is over 3 meters and not in the line of sight from main switchboard and an AC isolator device has not been provided."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "1",
        "clauseId": "SB & Labelling 1",
        "standardRef": "AS/NZS 5139:2019 CL7.3, Appendix B CLB2",
        "question": "Is signage, consisting of circular, green reflector, with the letters \"ES\", installed immediately on or adjacent to the meter box and switchboard, and is readily available to be seen by approaching emergency workers?",
        "recommendations": [
            "The \"ES\" sign has not been placed at the main switchboard as required.",
            "The \"ES\" sign has not been placed at the meter position as required.",
            "The \"ES\" sign is not visible on approach."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "2",
        "clauseId": "SB & Labelling 2",
        "standardRef": "AS/NZ S5139:2019 CL7.3, Appendix B CLB1",
        "question": "Is the ES sign at least 100mm in diameter, and does it contain the United Nations number for the primary chemistry written below the \"ES\" lettering, e.g. UN3480?",
        "recommendations": [
            "ES label is not the required 100mm in diameter as per AS/NZS 5139:2019 CL7.3",
            "Chemistry number UN3480 has not been labelled under the ES lettering as required.",
            "Label has been written with marker exposed to the elements which is not considered permanent."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "3",
        "clauseId": "SB & Labelling 3",
        "standardRef": "AS/NZS 5139:2019 CL7.4, Appendix B example Figure B.2",
        "question": "If the Battery Energy Storage System is not easily located, is there a plan or drawing showing the location of the Battery Energy Storage System located at the main switchboard which includes the location of shutdown procedures?",
        "recommendations": [
            "Battery system is not evident from the main switchboard, and a plan or drawing has not been provided as per AS/NZS 5139 Clause 7.4."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "4",
        "clauseId": "SB & Labelling 4",
        "standardRef": "AS/NZS5139:2019 CL7.6",
        "question": "If the Battery Energy Storage System is located adjacent (i.e. next to or adjoining without obstruction and within arm’s reach) to the switchboard and if multiple battery systems or BESS are installed, is there a sign for each that provides an identifiable number together with the total number of systems installed? For example, BESS 1 of 3?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "5",
        "clauseId": "SB & Labelling 5",
        "standardRef": "AS/NZS5139:2019 CL7.7",
        "question": "Is there a Safety Data Sheet (hard copy, not digital) installed within a document holder at the main switchboard or meter box?",
        "recommendations": [
            "A physical copy of the battery Safety Data Sheet (SDS) has not been installed within a document holder at the main switchboard or meter box as required."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "6",
        "clauseId": "SB & Labelling 6",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.3 (b) & (c)",
        "question": "If battery/inverter system is connected to the main switchboard has the grid supply main switch been labelled \"MAIN SWITCH (GRID)” or similar, alternatively if the battery/inverter system has been connected to a distribution board has a sign containing the words \"MAIN ISOLATOR (GRID)” or similar been placed adjacent to the isolator for the normal supply to the distribution switchboard.",
        "recommendations": [
            "The grid supply main switch/isolator has not been labelled at the switchboard to which the battery system is directly connected. Referencing Gateway."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "8",
        "clauseId": "SB & Labelling 8",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.3 (a)",
        "question": "Have supplementary supplies been labelled as “MAIN SWITCH (INVERTER)\" at the switchboard to which they are directly connected?",
        "recommendations": [
            "The inverter supplementary supply main switch has not been correctly labelled \"MAIN SWITCH (INVERTER)\"in Gateway"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "16",
        "clauseId": "SB & Labelling 16",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.8",
        "question": "Has a warning label been installed at the main switchboard and all intermediate distribution boards to indicate a multimode inverter with alternative supply has been installed and to follow the shutdown procedure for safe isolation, and is the text \"Neutral and earth circuits may be live under fault conditions\" included on this sign?",
        "recommendations": [
            "An alternative supply has been connected from the battery system/inverter, and the required label has not been placed in the main switchboard and/or any other switchboards energised by the battery system alternative supply. Referencing Gateway.",
            "At time of inspection an alternative supply had not been commissioned."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "17",
        "clauseId": "SB & Labelling 17",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.3 (g)",
        "question": "Do switchboards energised by battery system contain the label \"Multiple Supplies Isolate all Supplies before Working on this Switchboard”?",
        "recommendations": [
            "The gateway beside inverter contains multiple protection devices and as such is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "The gateway contains multiple protection devices and as such is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "The sub board with final sub circuits contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "18",
        "clauseId": "SB & Labelling 18",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.4",
        "question": "Where the inverter of the battery system is connected to a distribution board, is the following label present on the main switchboard and all intermediate distribution switchboards: “Warning Multiple Supplies Isolate Inverter Supply at Distribution Switchboard at …”?",
        "recommendations": [
            "The battery system has been connected to a distribution board (Gateway) and the correct label indicating which distribution board the battery system is connected too, has not been installed at the main switchboard."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "19",
        "clauseId": "SB & Labelling 19",
        "standardRef": "AS/NZS 3000 Clause 2.10.5.2; AS/NZS 4777.1:2024 Clause 5.3.6.1",
        "question": "Are circuits that are backed up when the grid is not available appropriately labelled to indicate their function?",
        "recommendations": [
            "Backed up circuits have not been labelled to indicate their function/source of supply.",
            "An attempt has been made to label backed up circuits, but more accurate labelling to indicate their function/source of supply."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "25",
        "clauseId": "SB & Labelling 25",
        "standardRef": "AS/NZS 4777.1:2019 Clause 7.2; AS/NZS 4777.1:2024 Clause 6.1",
        "question": "Are all signs and labels - (a) sufficiently durable and designed to have a lifetime greater than or equal to the service life of the battery system or BESS; (b) constructed of durable materials suitable for the location, and where installed exposed to direct sunlight, shall use UV stabilized materials; (c) fixed in a durable manner; (d) in English; (e) legible and in a letter size appropriate for the location (see guidance in Note 1); (f) indelible; and (g) visible, as required, at the installed position.",
        "recommendations": [
            "Label has been written in marker pen exposed to UV which is not deemed durable for the lifetime of the system.",
            "Label is starting to peel and is not deemed durable for the lifetime of the system.",
            "Label has fallen off and is not deemed sufficiently fixed for the lifetime of the system.",
            "Label's adjacent to battery storage unit are starting to peel and is not deemed durable for the lifetime of the system.",
            "Hazardous Voltage label has been written in marker pen exposed to UV which is not deemed durable for the lifetime of the system."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "28",
        "clauseId": "SB & Labelling 28",
        "standardRef": "AS/NZS 4777.1:2024 clause 6.3 (d)",
        "question": "Has the main switch for alternative supplies from the battery system/inverter been labelled \"MAIN SWITCH (ALTERNATIVE)\"?",
        "recommendations": [
            "The protective device for combined supplementary and alternative supply from the battery system has not been labelled \"MAIN SWITCH (ALTERNATIVE)\" as required in Gateway",
            "The protective device in the main switchboard is for combined supplementary and alternative supply from the battery system has not been labelled \"MAIN SWITCH (ALTERNATIVE)\" as required."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "13",
        "clauseId": "Integrated BESS 13",
        "standardRef": "AS/NZS 5139:2019 CL 7.6",
        "question": "Is there a sign adjacent to the lithium ion pre-assembled integrated BESS that states? a) Battery System or Battery Energy Storage System b) The correct short-circuit current (specifying current in amperes) c) The correct maximum d.c. voltage (specifying voltage in volts) For systems over DVC-A, the sign shall also state \"Hazardous d.c voltage\".",
        "recommendations": [
            "The short-circuit current and or maximum DC voltage rating for the installed battery system/s has not been filled in.",
            "The required label has not been installed at the battery system",
            "Hazardous DC voltage warning for systems exceeding DVC-A has not been provided",
            "The label has not been installed adjacent to the battery system as required it has been located at main switchboard."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "14",
        "clauseId": "Integrated BESS 14",
        "standardRef": "AS/NZS 5139:2019 CL 7.16",
        "question": "Is there a site-specific shutdown procedure that details the sequential steps to safely shutdown the BESS? The shutdown procedure shall be a) installed adjacent to the PCE to which the battery system is connected; and b) placed adjacent to and visible from the equipment to be operated in the event of a shutdown. All labelling of devices shall be consistent with terminology used in the shutdown procedure. The shut down procedure shall also state that isolation of the battery system by isolation and shutting down the PCE may not de-energize the battery system and further action may be required.",
        "recommendations": [
            "An alternative AC supply has been connected from the inverter to switchboard and shutdown procedure does not mention how to safely isolate this supply.",
            "An appropriate battery shutdown procedure has not been placed at the PCE or adjacent switchboard as required.",
            "Shutdown procedure does not mention how to shut down the battery system DC supply.",
            "Battery system DC isolator has not been labelled as per the shutdown procedure.",
            "Some items listed on the shutdown procedure do not align with the labels on electrical isolation equipment located onsite.",
            "The shutdown procedure shall state “isolation of the battery system by isolation and shutting down the PCE may not de-energise the battery system and further action may be required\" OR \"battery system d.c isolators do not de-energise the battery system and battery system cabling\"",
            "Some items listed on the shutdown procedure do not align with the labels on electrical isolation equipment located onsite. Please cross reference device labelling with shutdown procedure to ensure there is no confusion.",
            "Step 2 of shutdown procedure does not align with labelling.",
            "Shutdown procedure is not site specific - No mention of Gateway in procedure.",
            "No Labelling in Gateway as per shutdown procedure."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "15",
        "clauseId": "Integrated BESS 15",
        "standardRef": "AS/NZS 5139:2019 Table 3.1 AS/NZS 5139:2019 CL 7.8",
        "question": "If battery chemistry is categorised as a having a risk of battery explosion, has a \"Danger, Risk of Battery Explosion\" sign been installed in a prominent position approaching the battery system?",
        "recommendations": [
            "The manufacturers SDS lists a potential risk of battery explosion. As such a “danger, risk of battery explosion” label is required to be installed in a prominent position approaching the battery system."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "16",
        "clauseId": "Integrated BESS 16",
        "standardRef": "AS/NZS 5139:2019 CL 7.9",
        "question": "Is the \"Danger, toxic fumes\" sign installed adjacent to the enclosure or on all doors to the room where the battery system is located detailing the specific fault conditions (e.g. fire) under which the fumes will be present? This sign should also include PPE requirements for entering the room/working with the battery system.",
        "recommendations": [
            "As per AS/NZS 5139 clause 7.9 and table 3.1 all lithium-ion battery systems are required to have a “Danger, toxic fumes” sign installed adjacent to the enclosure or on all doors to the room where the battery system is located."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "17",
        "clauseId": "Integrated BESS 17",
        "standardRef": "AS/NZS 5139:2019 CL 7.11",
        "question": "If the battery chemistry is categorised as having an arc flash hazard above \"minor\" (see Table 6.1), is there a sign specifying the dangers of the arc flash? This sign shall be installed either adjacent to the enclosure or on all doors to the room where the battery system is located.",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "23",
        "clauseId": "Integrated BESS 23",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.1",
        "question": "Has the pre-assembled integrated BESS been installed in a location where it is protected from mechanical damage, or has sufficient protection been installed (Such as vehicle bollard/s to prevent damage by impact)? This also includes inappropriate or poorly installed infrastructure aimed at protecting it from mechanical damage.",
        "recommendations": [
            "The battery system has been installed in a carport or garage without adequate protection from vehicles. Recommend the installation of bollards or steel barriers.",
            "Single bollard in its current location does not provide adequate protection against potential battery system side and/or trailing edge impact from vehicles at this installation."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "41",
        "clauseId": "Integrated BESS 41",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.3(a)",
        "question": "If mounted on the ground, does the ground appear to be suitable to support the weight of the BESS?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "42",
        "clauseId": "Integrated BESS 42",
        "standardRef": "AS/NZS 5139:2019 CL 4.3.3(b)",
        "question": "If mounted on a wall or structure, does the wall or structure appear to have the structural integrity to withstand the weight of the BESS?",
        "recommendations": [
            "Wall mounting brackets have not been installed on battery storage unit as per manufacture's installation guidelines."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "10",
        "clauseId": "SB & Labelling 10",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.2; AS/NZS 3000:2018 Cl 2.5.3.1",
        "question": "Are all cables related to the battery installation, and not covered by other questions in this checklist, protected against overcurrent?",
        "recommendations": [
            "Battery supplementary supply cable is not sufficiently protected by the installed overcurrent protection device"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "20",
        "clauseId": "SB & Labelling 20",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.1 & 5.3.4",
        "question": "Are the inverter/battery supplementary supply cable and associated overcurrent protection device, rated higher than the summation of battery system charging current plus alternative supply overcurrent protection device rating or maximum demand of the alternative supply?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "29",
        "clauseId": "SB & Labelling 29",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.2; AS/NZS 3000:2018 Cl 2.5.3.1",
        "question": "Are all busbars in the installation rated, or protected against potential overcurrent from summation of grid and supplementary supplies? 80amp rated bus bar is not protected against overcurrent from summation of grid and supplementary supplies (highlighted in green)",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "30",
        "clauseId": "SB & Labelling 30",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.2; AS/NZS 3000:2018 Cl 2.5.3.1",
        "question": "Are all cables in the installation rated, or protected against overcurrent from summation of grid and supplementary supplies? 16mm2 feed conductors are not protected against overcurrent summation from grid and supplementary supplies, when 3-way switch is operated in grid supply mode. 10mm2 feed conductors are not protected against overcurrent summation from grid and supplementary supplies, when 3-way switch is operated in grid supply mode. 6mm2 feed conductors are not protected against overcurrent summation from grid and supplementary supplies, when 3-way switch is operated in grid supply mode. 16mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 10mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 6mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 4mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 2.5mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies.",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "31",
        "clauseId": "SB & Labelling 31",
        "standardRef": "AS/NZS 4777.1:2024 clause 5.3.5.1 AS/NZS 3000:2018 Clause 2.5.3.1",
        "question": "Where required, has overcurrent protection been provided for the alternative supply?",
        "recommendations": [
            "A multi-mode inverter with grid pass-through functionality has been installed, and insufficient overcurrent protection has been installed on the alternative supply cables."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "26",
        "clauseId": "SB & Labelling 26",
        "standardRef": "AS/NZS 3000:2018 Clause 2.10.7",
        "question": "Do all AC cables related to the battery installation, that pass-through penetrations in the switchboard enclosure, pass through a tight fit (less than 5mm diameter) to reduce the spread of fire?",
        "recommendations": [
            "Penetration in switchboard through which battery/inverter AC cables pass, is larger than 5mm in diameter and has not been sealed to protect against the spread of fire."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "35",
        "clauseId": "Integrated BESS 35",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.4.2 AS/NZS 5139:2019 Figure 4.2",
        "question": "Is the lithium ion pre-assembled integrated BESS located on, or placed against the wall, or mounted on the floor within 300mm of the wall or structure separating it from a habitable room, and where the surface of the wall is not made of a suitably non-combustible material, has a suitably non-combustible barrier been placed between the pre-assembled integrated BESS and the surface of the wall or structure to the required dimensions shown in AS/NZS 5139:2019 Figure 4.2?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "36",
        "clauseId": "Integrated BESS 36",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.4.2",
        "question": "Have all penetrations larger than 5mm through non-combustible material separating the battery system from a habitable room, within dimensions shown in AS/NZS 5139:2019 figure 4.2, been filled with a fire-retardant material?",
        "recommendations": [
            "Any penetration of the non-combustible barrier that has an internal free space greater than 5 mm diameter must be sealed with a fire-retardant sealant.",
            "Any penetration of the non-combustible barrier that has an internal free space greater than 5 mm diameter must be sealed with a fire-retardant sealant. Penetration to the right of battery storage unit in brickwork."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "26",
        "clauseId": "Integrated BESS 26",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.1",
        "question": "If installed in a corridor, hallway or lobby does the lithium-ion pre-assembled integrated BESS have at least 1 metre of clearance to allow for safe egress?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "27",
        "clauseId": "Integrated BESS 27",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.2",
        "question": "Is the pre-assembled integrated BESS not installed in any of the below restricted locations? (a) in restricted locations, as defined for switchboards in AS/NZS 3000; (b) within 600 mm of any exit that has an opening 900mm or less; (c) within 600 mm of any vertical side of a window or building ventilation that ventilates a habitable room; (e) within 900 mm below any of the items included in Items (b), (c); (f) in ceiling spaces; (g) in wall cavities; (h) on roofs, except where specifically deemed suitable; (i) under stairways; (j) under access walkways; or (k) in an evacuation route or escape route (with less than 1m of safe egress).",
        "recommendations": [
            "Battery storage unit has been installed on southern wall 200mm from pedestrian gate which does not completely open due to battery installation.",
            "Battery storage unit has been installed underneath access stairway.",
            "Battery storage unit has been installed on external wall within 500mm of eve that has combustible materials backing onto a habitable room."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "28",
        "clauseId": "Integrated BESS 28",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.2",
        "question": "Is the lithium-ion pre-assembled integrated BESS installed in a habitable room?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "29",
        "clauseId": "Integrated BESS 29",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.2",
        "question": "Are any fixed appliances not associated with the lithium-ion pre-assembled integrated BESS not installed within the restricted zones shown in AS/NZS 5139:2019 Figure 4.1?",
        "recommendations": [
            "Double GPO is within restriction zone - 200mm to the Right of battery storage unit."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "30",
        "clauseId": "Integrated BESS 30",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.2 AS/NZS 60079.14 AS/NZS 3000:2018 Section 7",
        "question": "If the lithium-ion pre-assembled integrated BESS installed does not conform to AS/NZS 60079.14, is the installation not in a location defined to be a hazardous area in AS/NZS 3000:2018 Section 7",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "31",
        "clauseId": "Integrated BESS 31",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.2.2 AS/NZS 3000:2018 Section 4",
        "question": "Is the lithium-ion pre-assembled integrated BESS installed away from hazardous areas for gas cylinders containing heavier-than-air gasses and gas relief vent terminals as defined in AS/NZS 3000:2018 Section 4?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "32",
        "clauseId": "Integrated BESS 32",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.3 AS/NZS 5139:2019 CL 4.2.3.2",
        "question": "Is the lithium-ion pre-assembled integrated BESS installed in a location that will not expose it to temperatures lower than the minimum or greater than the maximum temperatures as specified by the manufacturer?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "33",
        "clauseId": "Integrated BESS 33",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.3 AS/NZS 5139:2019 CL 4.2.3.2",
        "question": "Is the lithium-ion pre-assembled integrated BESS installed in a location where it can be protected against damage that might reasonably be expected from the presence of water, high humidity, dust, vermin or direct sunlight?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "34",
        "clauseId": "Integrated BESS 34",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.3 AS/NZS 5139:2019 CL 4.2.3.2",
        "question": "Is the lithium-ion pre-assembled integrated BESS installed in a location that will not expose it to localised or general heat sources? Such as direct sunlight, generators, stream pipes, hot water systems, air conditioners or space heaters. There should also be no direct airflow from any appliance directed at it.",
        "recommendations": [
            "General Recommendations",
            "Consent form signed Prior to inspection.",
            "Recalled battery terminal plug appears to be rectified.",
            "Potentially recalled battery and/or inverter found on site. Homeowner has been notified and recommended to contact manufacturer to check if their system is on the list and ensure fixes have been applied where applicable.",
            "Battery system has been installed in a room without a smoke alarm. Inspector recommends the installation of a smoke alarm or heat detector in line with Australian standards and building code recommendations.",
            "Battery system has been installed near combustible materials. AS/NZS 5139:2019 recommends battery systems not be installed near combustible materials.",
            "Battery system alternative supply not tested at time of audit. Unable to test for parallel earth neutral connections, or final sub circuit neutral continuity in backup mode as battery state of charge was too low to engage Alternate supply.",
            "At the time of the inspection the inspector did not sight all the documentation. As it cannot be denied if the documentation was handed over to the homeowners these items will not be displayed in the final report. It would be advised to review AS/NZS 5139:2019, to confirm if all required documentation was provided to the homeowners.",
            "Alternative supply was not operational at time of inspection, as such multiple MEN, and neutral continuity tests were unable to be performed on backed up circuits.",
            "Inspector noted that existing signage is present from previous installation - Recommend removing old signage to save confusion.",
            "The address listed on REC registry is incorrect. The consent provider has confirmed correct address and has acknowledged this by signing the consent form.",
            "Name on consent form differs from that listed on REC registry.",
            "Type \"AC\" RCD have been installed on final sub circuits supplied by alternative battery supply. Recommend replacing with a type designed to operate when impacted by d.c. waveform. AS/NZS 3000:2018 clause 2.6.2.2.1",
            "Battery system is an expansion to an existing installation, as such parts of the checklist relating to the original/pre-existing installation will not be assessed as part of this audit.",
            "Battery system is a pre-assembled integrated BESS",
            "Hardware onsite differs from what is listed on REC registry. A SigenStor EC 20.0 TP AU has been installed, and REC Registry shows a SigenStor-20T-48 (AS4777-2 2020) has been installed.",
            "Battery system alternative supply not tested at time of audit. Unable to test for parallel earth neutral connections, or final sub circuit neutral continuity in backup mode as customer did not wish for grid supply to be interrupted.",
            "Recalled battery terminal plug appears to be rectified",
            "Inspector unable to verify Anti Island test due to installation methods at main switchboard where Alternate supply and Grid supply are switched via double pole circuit breaker.",
            "Inspector could not access sub board in house to confirm labelling or if final sub circuit's had RCD protection. Please ensure sub board complies with current standards.",
            "Distribution board adjacent to battery storage unit had no internal inspection as cover had been silicone on.",
            "Inspector unable to determine if room behind battery storage unit is habitable room, recommend floor vent if habitable room is behind battery storage unit.",
            "Inspector unable to determine if room behind is habitable room, recommend sealing brick breathing holes."
        ]
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "11",
        "clauseId": "Integrated BESS 11",
        "standardRef": "Source document did not specify a standard reference",
        "question": "Was the lithium-ion integrated BESS an approved product on the Clean Energy Council's Approved battery list at the time of installation?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "12",
        "clauseId": "Integrated BESS 12",
        "standardRef": "Source document did not specify a standard reference",
        "question": "Has the lithium-ion integrated BESS been recalled by the manufacturer or regulator?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "20",
        "clauseId": "Integrated BESS 20",
        "standardRef": "AS/NZS 5139:2019 CL 4.2.1",
        "question": "Is the a.c. interconnection of the lithium-ion pre-assembled integrated BESS to the switchboard or distribution board in accordance with AS/NZS 3000? if not, does the defect pose a potential safety risk at some stage in the lifetime of the system?",
        "recommendations": []
    },
    {
        "group": "Integrated BESS",
        "itemNumber": "48",
        "clauseId": "Integrated BESS 48",
        "standardRef": "AS/NZS 3000:2018; AS/NZS 5139:2019; AS/NZS 5033:2021; AS/NZS 4777.1:2024",
        "question": "Has all electrical work associated with the installation of the lithium-ion pre-assembled integrated BESS been installed in line with Australian standards? If not, is the defect likely to pose a potential safety risk at some stage in the lifetime of the system?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "11",
        "clauseId": "SB & Labelling 11",
        "standardRef": "AS/NZS 4777.1:2024 Clause 5.3.6.2",
        "question": "Have battery/inverter systems utilising an alternative supply been supplied with an alternative supply main switch in the switchboard they are supplying?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "23",
        "clauseId": "SB & Labelling 23",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.5.3.1",
        "question": "Are there no more than 2 inverter main switches connected to any 1 switchboard with attached loads?2",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "24",
        "clauseId": "SB & Labelling 24",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.5.3.1",
        "question": "Where 2 inverter supplies are connected to a main switchboard or distribution board with other circuits and loads connected, are the inverter main switches grouped together?",
        "recommendations": [
            "Where multiple IES are connected directly to a main switchboard or a distribution board with other circuits and loads, and each has an inverter main switch, then the main switches shall be grouped."
        ]
    }
]
